import { EntityId } from '@shared/models/entity-id';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Media } from '@shared/models/media/media.model';

export interface AllowedOrganization {
  id: EntityId;
  name: string;
  description?: string | null;
  media?: Media[];
}

export interface SwitchOrganizationRequest {
  organization_id: EntityId;
}

export interface SwitchOrganizationResponse {
  accessToken: string;
  refreshToken: string;
}

interface RawSwitchOrganizationResponse {
  accessToken?: string;
  refreshToken?: string;
  access_token?: string;
  refresh_token?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OrganizationSessionApiService {
  private readonly http = inject(HttpClient);

  public getAllowedOrganizations(): Observable<AllowedOrganization[]> {
    const url = `${environment.host}:${environment.port}/api/organizations/allowed`;
    return this.http.get<AllowedOrganization[]>(url);
  }

  public switchOrganization(organizationId: EntityId): Observable<SwitchOrganizationResponse> {
    const url = `${environment.host}:${environment.port}/api/authentication/switch_organization/`;
    const body: SwitchOrganizationRequest = { organization_id: organizationId };
    return this.http.post<RawSwitchOrganizationResponse>(url, body).pipe(
      map((response) => ({
        accessToken: response.accessToken ?? response.access_token ?? '',
        refreshToken: response.refreshToken ?? response.refresh_token ?? '',
      })),
    );
  }
}
